export default __webpack_public_path__ + "media/images/images/gallery/126516-11fb4c299b53b6b98c71827818f9747c.svg";